<template lang="pug">
  main#app
    transition(name="fade")
      router-view
</template>

<script>
import SetupService from '@/services/setup.js'

export default {
  beforeRouteEnter (to, from, next) {
    SetupService.query()
    .then(response => {
      next()
    })
  },
  name: 'app'
}
</script>

<style lang="sass">
  @import "./assets/sass/common.sass"
  #app
    font-family: 'Poppins', 'Open Sans', Helvetica, Arial, sans-serif
    -webkit-font-smoothing: antialiased
    -moz-osx-font-smoothing: grayscale
    background: #e3e3e3
</style>



// WEBPACK FOOTER //
// App.vue?4c06cc96